module.exports = __webpack_public_path__ + "media/country_flags/cf-c7bbe52f.png";